import React from "react";
import Input from "../../../../../../../components/Input";
import InputSelect from "../../../../../../../components/Input-select";
import { remask } from "../../../../../../../libs/remask-mask";
import useImmolizedStore from "../../store/useStore";

const listStatusItens = [{ name: "Disponível" }, { name: "Em uso" }, { name: "Em manutenção" }, { name: "Doado" }, { name: "Vendido" }];

const LIST_LOCAL = [{ name: "Tegra" }, { name: "Home Office" }]

export default function Row3And4() {
  const { defaultValues } = useImmolizedStore();
  const { setDefaultValues, saveDataOfField, setState } = useImmolizedStore();
  
  function handleStatus(event) {
    const SELECT_VALUE = event.target.value
    const data = {
      ...defaultValues,
      status: SELECT_VALUE,
      isDeleted: verefyStatus(SELECT_VALUE)
    }
    setState(verefyStatus(SELECT_VALUE))
    setDefaultValues(data)
  }

  function verefyStatus(SELECT_VALUE) {
    if (SELECT_VALUE === 'Disponível' || SELECT_VALUE === "Em uso") return false
    return true
  }

  return (
    <>
      <div className="box-row">
        <Input
          name="purchase_date"
          label="Data da compra"
          placeholder="DD/MM/AAAA"
          value={remask(defaultValues?.purchase_date, ["99/99/9999"]) || defaultValues?.purchase_date}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="invoice_number"
          label="Nº Nota Fiscal"
          placeholder="Nota Fiscal"
          value={defaultValues?.invoice_number}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
      <div className="box-row">
        <InputSelect
          name="physical_location"
          label="Local Físico"
          placeholder="Local Físico"
          value={defaultValues?.physical_location}
          onChange={(event) => saveDataOfField(event.target)}
          list={LIST_LOCAL}
          required={true}
        />
        <InputSelect
          className="labelControllerSize"
          name="status"
          label="Status do Item"
          placeholder="Status do Item"
          value={defaultValues?.status}
          onChange={(event) => handleStatus(event)}
          list={listStatusItens}
          required={true}
        />
      </div>
    </>
  );
}
